import { AnimationOptions } from "motion";

export const animationCurves = {
  default: {
    duration: 0.5,
    ease: [0.5, 0, 0, 1],
  },
  macro: {
    duration: 0.8,
    ease: [0.5, 0, 0, 1],
  },
  long: {
    duration: 1.5,
    ease: [0.5, 0, 0, 1],
  },
  half: {
    duration: 0.25,
    ease: [0.5, 0, 0, 1],
  },
  quart: {
    duration: 0.125,
    ease: [0.5, 0, 0, 1],
  },
  easeOut: {
    ease: "easeOut",
  },
  gentleSpring: {
    type: "spring",
    stiffness: 256,
    damping: 24,
    mass: 1,
  },
} satisfies Record<string, AnimationOptions>;
